import { ISupplementARepository } from '../ports/outbound/ISupplementARepository';
import { SupplementAInterpreterForm } from '../../features/supplement-a/application/validators/supplement_a.schema';

export class SupplementAUseCase {
  constructor(private repo: ISupplementARepository) {}

  async addInterpreter(
    data: SupplementAInterpreterForm[],
    i9FormId: string
  ): Promise<SupplementAInterpreterForm[]> {
    return await this.repo.addInterpreter(data, i9FormId);
  }

  async updateInterpreter(
    data: SupplementAInterpreterForm[],
    i9FormId: string
  ): Promise<SupplementAInterpreterForm[]> {
    return await this.repo.updateInterpreter(data, i9FormId);
  }

  async deleteInterpreter(supplementAId: string): Promise<boolean> {
    return await this.repo.deleteInterpreter(supplementAId);
  }
}

export default SupplementAUseCase;
